/**
 * @flow
 */

import styled from 'react-emotion'
import Colors from '../../../themes/Colors'
import { mobile, tablet } from '../../../utils/mixins'
import { Typo30DarkGreyBlueTwoNBI } from '../../../themes/Fonts/Nort'
import BaseResponsiveContainer from '../../core/ResponsiveContainer'

export const Container = styled('div')`
  background-color: ${Colors.lightBlueTwo};
  padding-top: 50px;
  padding-bottom: 70px;
  ${mobile} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`
export const Title = styled(Typo30DarkGreyBlueTwoNBI)`
  text-align: center;
  ${mobile} {
    font-size: 26px;
  }
  margin: 0;
`
export const TitleUnderLine = styled('div')`
  width: 100px;
  height: 2px;
  background-color: ${Colors.pumpkinOrange};
  margin: auto;
  margin-top: 10px;
`
export const DevelopSectionContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 40px;
  ${mobile} {
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 0;
  }
  ${tablet} {
    flex-direction: column;
  }
`
export const ResponsiveContainer = styled(BaseResponsiveContainer)`
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/ApplicationSection/styledComponents.js